import Start from '../components/Start'
import Services from '../components/services/Services'
import About from '../components/about/About'
import Contact from '../components/contact/Contact'

export default [
  {
    path: '/',
    name: 'Start',
    component: Start,
    props: true,
    meta: {
      titleSE: 'Start',
      titleEN: 'Start'
    }
  },
  {
    path: '/services/:section?',
    name: 'Services',
    component: Services,
    props: true,
    meta: {
      titleSE: 'Tjänster',
      titleEN: 'Services'
    }
  },
  {
    path: '/about/:section?',
    component: About,
    props: true,
    meta: {
      titleSE: 'Om',
      titleEN: 'About'
    }
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: Contact,
    meta: {
      titleSE: 'Kontakta oss',
      titleEN: 'Contact us'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js